module.exports = __webpack_public_path__ + "img/back-print-blue.0e215b47.svg";